/**
 * Description: Dashboard router — renders the appropriate dashboard based on active context
 */

import React from 'react'
import { useUserContext } from '@context/UserContext'
import CPQDashboard from './dashboards/CPQDashboard'
import ServiceAssuranceDashboard from './dashboards/ServiceAssuranceDashboard'
import DigitalExperienceDashboard from './dashboards/DigitalExperienceDashboard'
import SuperAdminDashboard from './dashboards/SuperAdminDashboard'

const DASHBOARD_MAP: Record<string, React.FC> = {
  cpq: CPQDashboard,
  service_assurance: ServiceAssuranceDashboard,
  digital_experience: DigitalExperienceDashboard,
  superadmin: SuperAdminDashboard,
}

const Dashboard: React.FC = () => {
  const { activeContext, isLoading } = useUserContext()

  if (isLoading) {
    return (
      <div className="card py-12 text-center">
        <div className="border-primary-600 inline-block h-12 w-12 animate-spin rounded-full border-b-2"></div>
        <p className="mt-4 text-gray-500 dark:text-gray-400">Loading...</p>
      </div>
    )
  }

  if (!activeContext) {
    return (
      <div className="card py-12 text-center">
        <p className="text-gray-500 dark:text-gray-400">No context selected.</p>
      </div>
    )
  }

  const ContextDashboard = DASHBOARD_MAP[activeContext.name]

  if (!ContextDashboard) {
    return (
      <div className="card py-12 text-center">
        <p className="text-lg font-medium text-gray-600 dark:text-gray-400">
          {activeContext.display_name} Dashboard coming soon.
        </p>
      </div>
    )
  }

  return <ContextDashboard />
}

export default Dashboard
